<template>
  <div class="modal-wrapper">
    <div class="modal-dialog extra-large-modal" role="document">
      <div class="modal-content bill-payment__modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close', canReloadBills)" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Pagamentos da mensalidade
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <loading v-if="!billPayments" class="modal-body" full-screen="false" size="small" />
          <div v-else-if="billPayments.length === 0" class="centralized-horizontal modal-body">
            <p class="centralized-horizontal-item">
              Não existem meios de pagamento para esta mensalidade.
            </p>
          </div>
          <table v-else class="table table-striped table-bordered">
            <thead>
              <tr>
                <th class="table-centralized">
                  ID
                </th>
                <th class="table-centralized">
                  Status
                </th>
                <th class="table-centralized">
                  Tipo
                </th>
                <th class="table-centralized">
                  Valor mensalidade
                </th>
                <th class="table-centralized">
                  Valor pago
                </th>
                <th class="table-centralized">
                  Valor reembolsado
                </th>
                <th class="table-centralized">
                  Vencimento
                </th>
                <th class="table-centralized">
                  Pago em
                </th>
                <th class="table-centralized">
                  Parcelas
                </th>
                <th class="table-centralized">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody class="table table-striped table-bordered">
              <tr v-for="billPayment in billPayments" :key="billPayment.id" class="table-centralized">
                <td>
                  {{ billPayment.id }}
                </td>
                <td>
                  {{ billPayment.translated_status }}
                </td>
                <td>
                  {{ billPayment.translated_method_type }}
                </td>
                <td>
                  {{ billPayment.full_value | formatCurrency }}
                </td>
                <td>
                  {{ billPayment.paid_value | formatCurrency }}
                </td>
                <td>
                  {{ billPayment.refunded_value | formatCurrency }}
                </td>
                <td>
                  {{ billPayment.expiry_date | formatDate }}
                </td>
                <td v-if="billPayment.paid_at">
                  {{ billPayment.paid_at | formatDate }}
                </td>
                <td v-else>
                  -
                </td>
                <td>
                  {{ billPayment.installments }}x
                </td>
                <td>
                  <a
                    :href="`//beta.dashboard.pagar.me/#/transactions/${billPayment.psp_reference}`"
                    target="_blank"
                    class="btn btn-primary bill-payments-actions-button"
                    title="Link no Pagar.me"
                    v-if="billPayment.psp_reference"
                  >
                    <i class="fas fa-university"></i>
                  </a>

                  <button
                    class="btn btn-primary bill-payments-actions-button"
                    title="Baixar boleto"
                    :disabled="!billPayment.url"
                    @click="downloadBoleto(billPayment.id, billPayment.url)"
                  >
                    <i class="fas fa-download"></i>
                  </button>

                  <button
                    title="Copiar código"
                    class="btn btn-primary bill-payments-actions-button"
                    @click="copyCode(billPayment.bar_code || billPayment.metadata.qr_code)"
                    :disabled="!(billPayment.bar_code || billPayment.metadata.qr_code)"
                  >
                    <i class="fas fa-copy"></i>
                  </button>

                  <button
                    title="Fazer reembolso"
                    class="btn btn-danger bill-payments-actions-button"
                    @click="$emit('refundBillPayment', billPayment)"
                    :disabled="!canRefund(billPayment)"
                  >
                    <i class="fas fa-reply"></i>
                  </button>

                  <button
                    class="btn btn-primary bill-payments-actions-button"
                    @click="openPaymentTransferModal(billPayment)"
                    v-permissions:bill_payment.transfer
                    :disabled="!canShowActionsButton(billPayment)"
                    :title="!canShowActionsButton(billPayment)
                      ? 'O pagamento precisa estar pago' : 'Transferir pagamento'"
                  >
                    <i class="fas fa-redo vue-cropper tools--icon"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$emit('close', canReloadBills)">
            Fechar
          </button>
        </div>
      </div>
    </div>
    <payment-transfer-modal
      @close="closePaymentTransferModal"
      v-if="showPaymentTransferModal"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import BillPaymentService from 'services/BillPaymentService';
import Loading from 'components/Loading';
import Clipboard from 'utils/Clipboard';
import Permissions from 'mixins/Permissions';
import PaymentTransferModal from './PaymentTransferModal';

export default {
  mixins: [Permissions],

  data() {
    return {
      canReloadBills: false,
      showMore: false,
      billPayments: null,
      showPaymentTransferModal: false,
    };
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
  },
  components: {
    Loading,
    PaymentTransferModal,
  },
  mounted() {
    this.loadBillPayments();
  },
  methods: {
    ...mapMutations([
      'setSelectedPayment',
    ]),
    canRefund(billPayment) {
      return ['paid', 'partial'].includes(billPayment.status);
    },
    loadBillPayments() {
      BillPaymentService.getBillPaymentsOfBill(this.selectedBill.id)
        .then((billPayments) => {
          this.billPayments = billPayments;
        })
        .catch(({ body }) => {
          this.$alert.notifyAlert(`Erro ao carregar os meios de pagamento: ${body.message}`);
          this.$emit('close');
        });
    },
    downloadBoleto(billPaymentId, billPaymentUrl) {
      BillPaymentService.downloadBoleto(billPaymentId)
        .catch(() => {
          window.open(`${billPaymentUrl}?format=pdf`, '_blank').focus();
        });
    },
    copyCode(code) {
      Clipboard.copy(code);
      this.$alert.notifySuccess('Código copiado com sucesso!');
    },
    openPaymentTransferModal(billPayment) {
      this.showPaymentTransferModal = true;
      this.setSelectedPayment(billPayment);
      this.loadBillPayments();
    },
    closePaymentTransferModal(reloadBills) {
      this.showPaymentTransferModal = false;
      this.canReloadBills = reloadBills;
      this.setSelectedPayment(null);
    },
    canShowActionsButton(billPayment) {
      return billPayment.status === 'paid';
    },
  },
};
</script>

<style lang="scss" scoped>
  .bill-payments-actions-button:not(:last-child) {
    margin: 2px;
  }
</style>
